import React from "react";
import { ReactComponent as CloseIcon } from "./../../images/svg/x.svg";
import { gettext } from "../../adapter";
import { Map as LeafletMap, Marker, TileLayer } from "react-leaflet";
import { greenIcon, greyIcon, yellowIcon } from "../../utils/mapUtils";
import { useDispatch } from "react-redux";
import { selectFetchStation } from "../../actions/weatherStationsActions";

const iconSwitch = (station, selectedStation) => {
  var icon = greyIcon;
  if (station.period === "now") {
    icon = greenIcon;
  }
  if (selectedStation.id === station.id) {
    icon = yellowIcon;
  }
  return icon;
};

const WeatherDataMap = ({ apiUrl, closeMap, stations, selectedStation }) => {
  const dispatch = useDispatch();
  let bounds = stations.map(function (station) {
    return [station.latitude, station.longitude];
  });

  if (bounds.length < 1) bounds = null;

  // @TODO: Migrate
  // Add fields to the map
  // var wkt = new Wkt.Wkt();
  // cropr.cropfields.each(function (feature) {
  //   if (feature.get("geometry")) {
  //     wkt.read(feature.get("geometry"));
  //     wkt.toObject(feature.get("style")).addTo(_this.map);
  //   }
  // });

  return (
    <div className="l-full">
      <div className="viewswitch__overlay is-open">
        <h2>{gettext("Weatherstation map")}</h2>
        <div className="viewswitch__content">
          {/* eslint-disable-next-line */}
          <a className="viewswitch__close" onClick={closeMap}>
            <CloseIcon className="icon" />
          </a>

          <LeafletMap
            className="map small"
            bounds={bounds}
            id="map"
            zoom={16}
            boundsOptions={{ padding: [5, 5] }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            />
            {stations.map((station) => {
              return (
                <Marker
                  key={station.id}
                  icon={iconSwitch(station, selectedStation)}
                  position={[station.latitude, station.longitude]}
                  onClick={() => dispatch(selectFetchStation(apiUrl, station.id))}
                />
              );
            })}
          </LeafletMap>
        </div>
      </div>
    </div>
  );
};

export default WeatherDataMap;
